import React from 'react'
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox'
import SvgIcon from '@material-ui/core/SvgIcon'
import { makeStyles } from '@material-ui/core/styles'

import { ReactComponent as CheckboxSvg } from 'assets/icons/checkbox.svg'
import { ReactComponent as CheckboxActiveSvg } from 'assets/icons/checkbox-active.svg'

const useStyles = makeStyles({
  checkbox: {
    marginTop: '-2.5px',
    zIndex: 0,
    '&.Mui-disabled': {
      opacity: 0.6,
      '& svg': {
        color: 'rgba(0, 0, 0, 0.38)',
        '& path': {
          fill: 'rgba(0, 0, 0, 0.38)',
          stroke: 'rgba(0, 0, 0, 0.38)',
        },
        '& circle': {
          fill: 'rgba(0, 0, 0, 0.38)',
          stroke: 'rgba(0, 0, 0, 0.38)',
        },
        '& rect': {
          fill: 'rgba(0, 0, 0, 0.38)',
          stroke: 'rgba(0, 0, 0, 0.38)',
        },
      },
    },
  },
})

const CustomCheckbox: React.FC<CheckboxProps> = props => {
  const classes = useStyles()
  return (
    <Checkbox
      icon={
        <SvgIcon>
          <CheckboxSvg />
        </SvgIcon>
      }
      checkedIcon={
        <SvgIcon>
          <CheckboxActiveSvg />
        </SvgIcon>
      }
      className={classes.checkbox}
      {...props}
    />
  )
}

export { CustomCheckbox }
